module.exports = __webpack_public_path__ + "static/media/exe.9f67c3b8.svg";